/**
 * Generated runtime TestId mirror for frontend/src/pages/ApprovalPolicies.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ApprovalPoliciesTestIds = {
  approvalPoliciesList: "approval-policies-list",
  btnCreatePolicy: "btn-create-policy",
  colConditions: "col-conditions",
  colName: "col-name",
  colPolicyType: "col-policy-type",
  colPriority: "col-priority",
  colStatus: "col-status",
  colSteps: "col-steps",
  badgePolicyType: (policy_id: string) => `badge-policy-type-${policy_id}`,
  badgePolicyTypePrefix: () => "badge-policy-type-" as TestIdPrefix,
  linkPolicy: (policy_id: string) => `link-policy-${policy_id}`,
  linkPolicyPrefix: () => "link-policy-" as TestIdPrefix,
  policyRow: (policy_id: string) => `policy-row-${policy_id}`,
  policyRowPrefix: () => "policy-row-" as TestIdPrefix
} as const;
